import './Error.css'
const Error = () => {
    return (
        <div className='error'>
            Opps! Something went wrong, please check your internet connection or try again later.
        </div>
    )
}
export default Error;